/* eslint-disable array-bracket-newline */
// import
import { useEffect, useState } from 'react';
import { Network } from '@kattana-io/common';

import { useNetwork } from 'wagmi';

import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import ethereum from '../../assets/images/chains/ethereum.svg';
import bsc from '../../assets/images/chains/bsc_chain.svg';
import polygon from '../../assets/images/chains/polygon.svg';
import optimism from '../../assets/images/chains/optimism.svg';
// import arbitrum from '../../assets/images/chains/arbitrum.svg';
// import gnosis from '../../assets/images/chains/gnosis.svg';
// import heco from '../../assets/images/chains/heco.svg';
import avalance from '../../assets/images/chains/avalance.svg';
import fantom from '../../assets/images/chains/fantom.svg';
import bttc from '../../assets/images/chains/bttc.svg';
import elrond from '../../assets/images/chains/elrond.svg';
import tron from '../../assets/images/chains/tron.svg';
import okex from '../../assets/images/chains/okex.png';
// import klaytn from '../../assets/images/chains/klaytn.svg';
// import aurora from '../../assets/images/chains/aurora.svg';
import shevron from '../../assets/images/shevron_down.svg';

import './styles.scss';

// type INetworkParseNaming = {
//   [name: string]: string;
// };

interface INetworkSelectorProps {
  textSize?: 16 | 14;
  textWeight?: '500' | '600';
  imageSize?: 'l' | 'm';
}

// const networkParseNaming: INetworkParseNaming = {
//   Ethereum: 'ETH',
//   'BSC Chain': 'BSC',
//   Polygon: 'POLYGON',
//   Optimism: 'OPTIMISM',
//   Arbitrum: 'ARBITRUM',
//   Gnosis: 'GNOSIS',
//   Heco: 'HECO',
//   Avalanche: 'AVAX',
//   Fantom: 'FANTOM',
//   Klaytn: 'KLAYTN',
//   Aurora: 'AURORA',
// };

export const networks = [
  {
    chain: 'Ethereum',
    slug: 'ETH',
    image: ethereum,
    id: 1,
  },
  {
    chain: 'BSC',
    slug: 'BSC',
    image: bsc,
    id: 56,
  },
  {
    chain: 'Polygon',
    slug: 'POLYGON',
    image: polygon,
    id: 137,
  },
  {
    chain: 'Optimism',
    slug: 'OPTIMISM',
    image: optimism,
    id: 10,
  },
  {
    chain: 'Avalanche',
    slug: 'AVAX',
    image: avalance,
    id: 43114,
  },
  {
    chain: 'Fantom',
    slug: 'FTM',
    image: fantom,
    id: 250,
  },
  {
    chain: 'BTTC',
    slug: 'BTTC',
    image: bttc,
    id: 1029,
  },
  {
    chain: 'MultiversX',
    slug: 'ELROND',
    image: elrond,
    id: 999999,
  },
  {
    chain: 'OKT Chain',
    slug: 'OKX',
    image: okex,
    id: 66,
  },
  // {
  //   chain: 'Klaytn',
  //   image: klaytn,
  //   id: 8217,
  // },
  // {
  //   chain: 'Aurora',
  //   image: aurora,
  //   id: 1313161554,
  // },
  // {
  //   chain: 'Arbitrum',
  //   slug: 'ARBITRUM',
  //   image: arbitrum,
  //   id: 42161,
  // },
  // {
  //   chain: 'Gnosis',
  //   image: gnosis,
  //   id: 100,
  // },
  // {
  //   chain: 'Heco',
  //   slug: 'HECO',
  //   image: heco,
  //   id: 128,
  // },
];
export const network_with_data = [
  {
    chain: 'Ethereum',
    slug: 'ETH',
    image: ethereum,
    id: 1,
  },
  {
    chain: 'BSC',
    slug: 'BSC',
    image: bsc,
    id: 56,
  },
  {
    chain: 'Polygon',
    slug: 'POLYGON',
    image: polygon,
    id: 137,
  },
  {
    chain: 'Avalanche',
    slug: 'AVAX',
    image: avalance,
    id: 43114,
  },
  {
    chain: 'Fantom',
    slug: 'FTM',
    image: fantom,
    id: 250,
  },
  {
    chain: 'TRON',
    slug: 'TRON',
    image: tron,
    id: 999998,
  },
  {
    chain: 'MultiversX',
    slug: 'ELROND',
    image: elrond,
    id: 999999,
  },
  {
    chain: 'OKT Chain',
    slug: 'OKX',
    image: okex,
    id: 66,
  },
];

export const onChangeNetwork = (id: number) => {
  if (id === 1) {
    (window as any).ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: '0x1' }],
    });
    return;
  }

  const network = Network.fromChainId(id);
  if (network) {
    const nativeCurrency = {
      name: network.getNativeCurrencySymbol(),
      symbol: network.getNativeCurrencySymbol(),
      decimals: 18,
    };

    const rpc = network.getRPC();

    (window as any).ethereum.request({
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: network.toHex(),
          chainName: network.getName(),
          ...(nativeCurrency ? { nativeCurrency } : {}),
          ...(rpc ? { rpcUrls: [rpc] } : {}),
          //   blockExplorerUrls: ['https://ftmscan.com'], // TODO: suggestion: remove tx/ from network.getScan()
        },
      ],
    });
  }
};

const NetworkSelector = ({
  textSize = 14,
  textWeight = '600',
  imageSize = 'm',
}: INetworkSelectorProps) => {
  const { chain } = useNetwork();
  const [currentNetwork, setCurrentNetwork] = useState<any>();

  useEffect(() => {
    const [currentNetwork] = networks.filter((item) => item.id === chain?.id);
    setCurrentNetwork(currentNetwork);
  }, [chain]);

  const [isOptionMenuVisible, setVisible] = useState(false);

  const onClick = (e: any, id: number) => {
    e.stopPropagation();
    onChangeNetwork(id);
    setVisible(false);
  };

  if (!chain?.id) {
    return null;
  }

  return (
    <div className='network_selector'>
      <div
        className='network_selector__selected'
        onClick={() => setVisible(!isOptionMenuVisible)}
      >
        {currentNetwork && (
          <Image src={currentNetwork.image} size={imageSize} />
        )}
        {currentNetwork ? (
          <Text
            size={textSize}
            className={`text--grey-400 text--weight-${textWeight}`}
          >
            {currentNetwork.chain}
          </Text>
        ) : (
          <Text
            size={textSize}
            className={`text--grey-400 text--weight-${textWeight}`}
          >
            Unknown
          </Text>
        )}
        <Image size='m' src={shevron} className='network_selector__dropdown_icon' />
      </div>

      {isOptionMenuVisible && (
        <>
          <div
            className='network_selector__backdrop'
            onClick={() => setVisible(false)}
          />
          <div className='network_selector__background'>
            <div className='network_selector__optionsMenu'>
              {networks.map((item) => (
                <div
                  key={item.chain}
                  onClick={(e) => onClick(e, item.id)}
                  className={`network_selector__optionsMenu__item ${
                    item.id === chain.id
                      ? 'network_selector__optionsMenu__item--active'
                      : ''
                  }`}
                >
                  <Image src={item.image} size={imageSize} />
                  <Text
                    size={textSize}
                    className={`text--grey-400 text--weight-${textWeight}`}
                  >
                    {item.chain}
                  </Text>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NetworkSelector;
